import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import styles from './styles.scss';

class InputImageWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    }
  }

  componentDidMount() {
    document.addEventListener('dragover', this.onDocumentDragOver, false);
    document.addEventListener('drop', this.onDocumentDrop, false);
    this.targetArea.addEventListener('dragenter', this.onTargetAreaDragEnter, false);
    this.targetArea.addEventListener('dragleave', this.onTargetAreaDragLeave, false);
  }

  componentWillUnmount() {
    document.removeEventListener('dragover', this.onDocumentDragOver);
    document.removeEventListener('drop', this.onDocumentDrop);
    this.targetArea.removeEventListener('dragenter', this.onTargetAreaDragEnter);
    this.targetArea.removeEventListener('dragleave', this.onTargetAreaDragLeave);
  }

  onDocumentDragOver = e => {
    e.stopPropagation();
    e.preventDefault();
  }

  onDocumentDrop = e => {
    e.stopPropagation();
    e.preventDefault();
    this.props.onChange(e.dataTransfer.files);
  }

  onTargetAreaDragEnter = e => {
    e.preventDefault();
    this.setState({ hover: true });
  }

  onTargetAreaDragLeave = e => {
    e.preventDefault();
    this.setState({ hover: false });
  }

  handleChangeFile = (e) => {
    this.props.onChange(e.target.files);
  }

  render() {
    return (
      <label>
        <div ref={e => this.targetArea = e} style={this.state.hover ? { opacity: 0.6 } : {}}>
          <input
            type="file"
            accept="image/png, image/jpeg"
            ref="file"
            styleName="imageSelector"
            onChange={this.handleChangeFile}>
          </input>
          {this.props.children}
        </div>
      </label>
    );
  }
}

export default CSSModules(InputImageWrapper, styles);
